














import Vue from 'vue';
import BaseIcon from '@core/components/UI/BaseIcon.vue';
import { Headline } from '@headlines/types/headline';

interface Props {
  authors: Headline['authors'];
  headline: Headline;
}

interface Computed {
  isPaid: boolean;
  channelLabel: string | boolean;
  authorNames: string | boolean;
}

export default Vue.extend<unknown, unknown, Computed, Props>({
  name: 'HeadlineAuthor',
  components: {
    BaseIcon,
  },
  props: {
    authors: {
      type: Object,
      required: true,
    },
    headline: {
      type: Object,
      required: false,
      default: null,
    },
  },
  computed: {
    isPaid() {
      if (!this.headline) {
        return false;
      }

      return (this.headline.content.paywall && this.headline.content.paywall.enabled == true) || false;
    },
    channelLabel() {
      if (!this.headline) {
        return false;
      }

      const channel = this.headline.primaryCategory?.channel;
      switch (channel?.path) {
        case 'm360':
          return 'M360';
        case 'login':
        case 'verslasplius':
          return channel?.name;
        default:
          return false;
      }
    },
    authorNames() {
      let names: Array<string> = [];

      if (this.authors.items.length) {
        this.authors.items.forEach(author => {
          names.push(author.name);
        });
      }

      return names.join(', ') || false;
    },
  },
});
